import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

// @ts-ignore
import * as data from '../../../config/kla.json';
import { FullMenuSection, KlaData, Package, SubPackage } from '../tools/services/kla.data.models';

import { CustomPageComponent } from '../../custom-page/custom-page/custom-page.component';
import { IsPageEnabledGuard } from '../../core/guards/is-page-enabled.guard';
import { StripSpecialCharsPipe } from '../tools/strip-special-chars/strip-special-chars.pipe';
import { BehaviorSubject } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: "root" })
export class DataService {

  public static _isMaintenance = new BehaviorSubject(false);
  public static maintenanceDescription;
  static patformID;
  static data;
  static isLivePreview = false;
  private livePreviewData;

  constructor(
    @Inject(PLATFORM_ID) platformID
  ) {
    DataService.patformID = platformID;
  }

  static get HEADER_MENU_ITEMS() {
    const menuItems = [];
    for (const page of DataService.getData().pages) {
      if (page.layout === 'privacy-policy') {
        continue;
      }
      if (page.layout === 'external') {
        menuItems.push({
          state: page.url,
          name: page.name,
          type: 'external'
        });
        continue;
      }
      if (page.isEnabled) {
        menuItems.push({
          state: !DataService.isLivePreview ? [page.url.replace('/', '')] : ['preview', page.url.replace('/', '')],
          name: (page.layout === 'posts') ? 'News And Events' : page.name,
          type: 'link'
        });
      }
    }
    return menuItems;
  }

  static getData() {
    if (DataService.isLivePreview && DataService.data) {
      return DataService.data.default ? DataService.data.default : DataService.data;
    }
    return data;
  }

  static get isMaintenance(): boolean {
    return DataService._isMaintenance.value && !DataService.isLivePreview;
  }

  static set isMaintenance(value: boolean) {
    DataService._isMaintenance.next(value);
  }

  static get API_URL() {
    return DataService.getData().apiConfig.server + '/' + DataService.getData().apiConfig.version + '/';
  }

  static get LOGO_ID() {
    return DataService.getData().logo.image;
  }

  static get LOGO_DATA() {
    return DataService.getData().logo;
  }

  static get BANNER_DATA() {
    return this.getPage('/home').details;
  }

  static get FOOTER_DATA() {
    return DataService.getData().footer;
  }

  public static getPage(pageUrl) {
    return DataService.getData().pages.find(page => StripSpecialCharsPipe.strip(page.url) == StripSpecialCharsPipe.strip(pageUrl) && page.isEnabled);
  }

  public static getDashboardPage(pageUrl) {
    return DataService.getData().pages.find(page => page.url == pageUrl);
  }


  public static getDashboardData(): Array<FullMenuSection> {
    const dashboard = DataService.getPage('/dashboard');
    const sections: Array<FullMenuSection> = [];
    const section: FullMenuSection = {
      subTitle: dashboard.name,
      components: []
    };
    dashboard.details.packages.forEach((pack: Package) => {
      const component = {
        image: pack.packageDetails.image,
        cropConfig: pack.packageDetails.cropConfig,
        title: pack.packageDetails.name,
        isVisible: pack.packageDetails.isVisible,
        lineColor: pack.packageDetails.color,
        description: pack.packageDetails.description,
        menuList: []
      };
      pack.subPackages.forEach((subPack: SubPackage) => {
        component.menuList.push({
          lineSize: 'line-small',
          text: subPack.link.title,
          link: subPack.link,
          routeFragment: subPack.fragment,
          isVisible: subPack.link.isVisible
        });
      });
      section.components.push(component);
    });
    sections.push(section);
    return sections;
  }

  public static get IS_V4_MENU_LAYOUT(): boolean {
    return DataService.getData().theme[5].colors.dashboardHeader;
  }

  public static get DASHBOARD_DATA() {
    return DataService.getDashboardData();
  }

  public static get CUSTOM_PAGE_ROUTES() {
    const urlArray = [];
    const pages = DataService.getData().pages.filter(page => page.layout.includes('custom') && page.isEnabled);
    for (const page of pages) {
      urlArray.push(
        {
          path: page.url.replace('/', ''),
          component: CustomPageComponent,
          canActivate: [IsPageEnabledGuard]
        }
      );
    }

    return urlArray;
  }

  public static get DEFAULT_PAGE_URL() {
    const search = isPlatformBrowser(DataService.patformID) ? window.location.search : '';
    if (DataService.isLivePreview) {
      return 'preview' + DataService.getData().defaultPageUrl + search;
    }
    return DataService.getData().defaultPageUrl.replace('/', '') + search;
  }

  public static get analyticsMeasurementId(): string {
    let propString;
    propString = DataService.getData().analytics_measurement_id;
    if (!propString) {
      return '';
    }
    return propString;
  }

  public static get hotjarId(): string {
    let propString;
    propString = DataService.getData().hotjar_id;
    if (!propString) {
      return '';
    }
    return propString;
  }

  public getDataFromBackend(received) {
    DataService.isLivePreview = true;
    const site = received.data;

    if (!site) {
      return;
    }

    let data1: KlaData;
    let config: string;

    if (site && site.config && site.config.config) {
      config = site.config.config;
      data1 = JSON.parse(config);
    }
    if (site && site.fullConfig) {
      data1 = site.fullConfig;
    }

    if (this.livePreviewData) {
      const equal = this.livePreviewData === config;
      if (equal) {
        return;
      }
    }

    this.livePreviewData = config;
    if (data1 && data1.pages) {
      data1.pages.forEach(page => {
        if (page && page.details && page.details.packages) {
          page.details.packages.forEach((pack, packIndex) => {
            if (!pack.fragment) {
              pack.fragment = 'p' + packIndex;
            }
            if (pack.subPackages) {
              pack.subPackages.forEach((subPack, subIndex) => {
                if (!subPack.fragment) {
                  subPack.fragment = 'sp' + packIndex + '' + subIndex;
                }
              });
            }
          });
        }
      });
    }
    DataService.data = data1;
  }

}
